import { CustomColumnDef } from './customColumnDef';

const SINGLE_VALUE_DROPDOWN_TYPES = ['default', 'searchDropdown'];

export function dropSubheaderValuesMissingFromOptions(
	subheaderValues: Record<string, any>,
	columns: CustomColumnDef<any>[],
): Record<string, any> {
	const staleColumnIds = columns
		.filter(({ subHeaderDropdownType }) => SINGLE_VALUE_DROPDOWN_TYPES.includes(subHeaderDropdownType ?? ''))
		.filter(({ id, subHeaderDropdownOptions = [] }) => {
			const value = subheaderValues[id as string];
			return (
				!!value &&
				subHeaderDropdownOptions.length > 0 &&
				!subHeaderDropdownOptions.some((option) => option.value === value)
			);
		})
		.map(({ id }) => id as string);

	if (staleColumnIds.length === 0) return subheaderValues;

	return Object.fromEntries(Object.entries(subheaderValues).filter(([columnId]) => !staleColumnIds.includes(columnId)));
}
